// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".visitor-table {\n  margin-bottom: 10px;\n}\n.visitor-table tr:hover {\n  cursor: pointer !important;\n}\n.visitor-table th {\n  background: whitesmoke !important;\n}\n.visitor-table.loading {\n  opacity: 0.6;\n  pointer-events: none;\n}", ""]);
// Exports
module.exports = exports;
